import { useMemo } from 'react'

export const useStaticPage = () => {
  const StaticPageEnvironment = process.env.StaticPageEnvironment as 'development' | 'production'

  const baseUrl = useMemo(() => {
    const sub = StaticPageEnvironment === 'development' ? 's-dev' : 's'
    return `https://${sub}.roov.space/`
  }, [StaticPageEnvironment])

  /** 利用環境ページのURL */
  const usageEnvironmentPageUrl = useMemo(() => {
    return `${baseUrl}roov-system-requirements.html`
  }, [baseUrl])

  return {
    usageEnvironmentPageUrl,
  }
}
